import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({
  id,
  input,
  options,
  disabled
}) => (
  <select
    id={id}
    value={input.value}
    onChange={(e) => {
      input.onBlur();
      input.onChange(e.target.value);
    }}
    disabled={disabled}
  >
    {
      options.map((option) => (
        <option
          id={`${id}-${option.value}`}
          key={`${id}-${option.value}`}
          value={option.value}
        >
          {Monet.I18n.getResourcesByKey(option.label)}
        </option>
      ))
    }
  </select>
);

const gridFormatter = ({ label, name, options }) => ({
  id: name,
  name,
  label,
  fieldDomains: options.map((option) => ({ description: option.label, ...option })),
  type: 'PICKLIST'
});

const SelectField = (props) => {
  const {
    options, defaultValue, required, ...remainingProps
  } = props;

  return (
    <BaseField
      fieldClassName="selectField"
      renderFieldContent={renderFieldContent}
      gridFormatter={gridFormatter}
      defaultValue={defaultValue || options[0].value}
      options={options}
      required={required}
      {...remainingProps}
    />
  );
};

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

renderFieldContent.defaultProps = {
  disabled: false
};

SelectField.propTypes = {
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.string,
  required: PropTypes.bool
};

SelectField.defaultProps = {
  defaultValue: null,
  required: false
};

export default SelectField;
